import script from "./GradientWithContent.vue?vue&type=script&setup=true&lang=js"
export * from "./GradientWithContent.vue?vue&type=script&setup=true&lang=js"

import "./GradientWithContent.vue?vue&type=style&index=0&id=eb569628&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb569628"]])

export default __exports__